export const DevelopmentCommunityGoals = ({ developmentCommunityGoals }: any) => {
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              Development and Community Goals
            </h2>
            <p className='mt-1 max-w-2xl text-sm text-gray-500'>Information about the development and community goals</p>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mb-8'>
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>Development and Community Goals</dt>
              <dd className='mt-1 text-sm text-gray-900'>
                {developmentCommunityGoals?.goals?.map((g: any, index: number) => (
                  <span key={index}>{g}, </span>
                ))}
                <span>{developmentCommunityGoals?.other}</span>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
};
